import axios from "axios";
import {
  baseURL,
  contentType,
  invalidCode,
  messageDuration,
  noPermissionCode,
  requestTimeout,
  successCode,
  debounce,
} from "@/config/settings";
import { Loading, Message } from "element-ui";
import qs from "qs";
import router from "@/router";
import _ from "lodash";
import { isArray, isNumber } from "@/utils/validate";
import Vue from "vue";
import i18n, { getApiLanguageHeader } from "@/i18n";
import store from "@/store";
import { resetSessionCheck } from "@/utils/auth";

const service = axios.create({
  baseURL,
  timeout: requestTimeout,
  withCredentials: true,
  headers: {
    "Content-Type": contentType,
  },
});
let loadingInstance;
service.interceptors.request.use(
  (config) => {
    config.headers["X-Language"] = getApiLanguageHeader();
    if (process.env.NODE_ENV !== "preview") {
      if (contentType === "application/x-www-form-urlencoded;charset=UTF-8") {
        if (config.data) {
          config.data = qs.stringify(config.data);
          console.log(config.data);
        }
      }
    }
    //需要loading的接口
    const needLoading = () => {
      let status = false;
      debounce.forEach((item) => {
        if (_.includes(config.url, item)) {
          status = true;
        }
      });
      return status;
    };
    if (needLoading()) {
      loadingInstance = Loading.service();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const errorMsg = (message) => {
  return Message({
    message: message,
    type: "error",
    duration: messageDuration,
  });
};

service.interceptors.response.use(
  (response) => {
    if (loadingInstance) {
      loadingInstance.close();
    }
    const { data, config } = response;
    const { code, msg } = data;
    let codeVerification = false;

    if (isNumber(successCode)) {
      codeVerification = code !== successCode;
    }
    if (isArray(successCode)) {
      for (let i = 0; i < successCode.length; i++) {
        if (code === i) {
          codeVerification = code !== i;
          break;
        }
      }
    }
    if (codeVerification) {
      // session 探测：未登录返回 code=-1 属正常，交给调用方处理
      if (config.skipAuthRedirect && code === -1) {
        return data;
      }
      if (
        code === -1 &&
        !config.skipAuthRedirect &&
        config.url &&
        config.url.indexOf("delivery/") === 0
      ) {
        store.commit("clearAuth");
        store.commit("setAuthChecked", true);
        resetSessionCheck();
        if (router.currentRoute.path !== "/login") {
          router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath },
          });
        }
      }
      switch (code) {
        case invalidCode:
          errorMsg(msg || i18n.t("request.apiError", { code }));
          break;
        case noPermissionCode:
          router.push({
            path: "/401",
          });
          break;
        default:
          if (code !== -1) {
            errorMsg(msg || i18n.t("request.apiError", { code }));
          }
          break;
      }
      Vue.prototype.bus.$emit("loading", false);
      return Promise.reject(
        "请求异常拦截:" +
          JSON.stringify({
            url: config.url,
            code,
            msg,
          }) || "Error"
      );
    } else {
      // console.log('666',data)
      return data;
    }
  },
  (error) => {
    if (loadingInstance) {
      loadingInstance.close();
    }
    /*网络连接过程异常处理*/
    let { message } = error;
    if (message == "Network Error") {
      message = i18n.t("request.networkError");
    }
    if (message.includes("timeout")) {
      message = i18n.t("request.timeout");
    }
    if (message.includes("Request failed with status code")) {
      const code = message.substr(message.length - 3);
      message = i18n.t("request.statusError", { code });
    }
    Vue.prototype.bus.$emit("loading", false);
    errorMsg(message || i18n.t("request.unknownError"));
    return Promise.reject(error);
  }
);
export default service;
